/**
 * /not-found — catch-all fallback for unknown authenticated routes.
 *
 * Round 5 Item 7 refactor (2026-06-25): now uses the canonical
 * <BrandedFaultRoute /> primitive. Don't add per-route fault chrome here;
 * the primitive owns the visual frame so 404 / 403 / 500 / etc. all feel
 * like the same product.
 */

import { BrandedFaultRoute, FaultCtaHome } from '../components/BrandedFaultRoute.tsx';

export function NotFound() {
  return (
    <BrandedFaultRoute
      kind="info"
      iconKind="home"
      eyebrow="404"
      title="We can't find that page."
      body="The link may be stale or the URL has a typo. Head back to your home and try again."
      actions={<FaultCtaHome />}
    />
  );
}
